import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  submit() {
    this.buttonTarget.disabled = true
    this.buttonTarget.value = "Submitting..."
  }
}